import { getAdminToken } from '../api'
import type { KnowledgeScope } from '../constants/knowledgeScope'

export function knowledgeDocPreviewPath(
  itemId: number,
  scope: KnowledgeScope,
  query = '',
  options?: { highlightKvs?: string[]; fromItemId?: number },
): string {
  const params = new URLSearchParams({ scope })
  const q = query.trim()
  if (q) params.set('q', q)
  const fromId = Number(options?.fromItemId ?? 0)
  if (Number.isFinite(fromId) && fromId > 0) params.set('from_item', String(fromId))
  for (const kv of options?.highlightKvs ?? []) {
    const s = kv.trim()
    if (s) params.append('rel_kv', s)
  }
  return `/search/preview/${itemId}?${params.toString()}`
}

/** 在线文档编辑页（新建标签页） */
export function knowledgeDocEditPath(itemId: number, scope: KnowledgeScope): string {
  const base = scope === 'enterprise' ? '/enterprise/create' : '/knowledge/create'
  return `${base}?id=${itemId}&mode=edit`
}

export function openKnowledgeDocEdit(
  itemId: number,
  scope: KnowledgeScope,
  options?: { onNeedLogin?: () => void },
): boolean {
  if (!getAdminToken()) {
    options?.onNeedLogin?.()
    return false
  }
  window.open(knowledgeDocEditPath(itemId, scope), '_blank', 'noopener,noreferrer')
  return true
}

/** 新标签页打开文档预览（需管理账号 JWT） */
export function openKnowledgeDocPreview(
  itemId: number,
  scope: KnowledgeScope,
  options?: { query?: string; onNeedLogin?: () => void },
): boolean {
  if (!getAdminToken()) {
    options?.onNeedLogin?.()
    return false
  }
  window.open(
    knowledgeDocPreviewPath(itemId, scope, options?.query ?? ''),
    '_blank',
    'noopener,noreferrer',
  )
  return true
}
